import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class CourseQueryFilter extends QueryFilter{
    public state: string;
}